import React, { useCallback, memo } from 'react';
import { connect } from 'react-redux';
import ToggleButtonListItem from '../../../../../../list-items/ToggleButtonListItem';
import { createActions } from '../../../../store';
import { REFLECTION_TYPE, VISUALIZER_SHAPE } from '../../../../Preview/PreviewDisplayConstants';

const reflectionTypeOptionsCircle = [
    { value: REFLECTION_TYPE.NONE, text: 'None' },
    { value: REFLECTION_TYPE.VERTICAL, text: 'Vertical' },
    { value: REFLECTION_TYPE.SLANTED, text: 'Across' },
    { value: REFLECTION_TYPE.THREE_WAY, text: '3-Way' },
    { value: REFLECTION_TYPE.FOUR_WAY, text: '4-Way' }
];

const reflectionTypeOptionsFlat = [
    { value: REFLECTION_TYPE.NONE, text: 'None' },
    { value: REFLECTION_TYPE.ONE_SIDE, text: '1 Side' },
    { value: REFLECTION_TYPE.TWO_SIDE, text: '2 Sides' },
    { value: REFLECTION_TYPE.COMBO, text: 'Combo' },
];

const WaveLayerReflectionTypeListItem = memo(({ index, reflectionType, visualizerShape, updateWaveLayerCustomOptions }) => {
    const shapeIsCircle = visualizerShape === VISUALIZER_SHAPE.CIRCLE;

    const handleChange = useCallback(
        (value) => updateWaveLayerCustomOptions(index, "reflectionType", value),
        [index]
    );

    return (
        <ToggleButtonListItem
            text='Reflection'
            value={reflectionType}
            onChange={handleChange}
            options={shapeIsCircle ? reflectionTypeOptionsCircle : reflectionTypeOptionsFlat}
            lineBreak={shapeIsCircle}
        />
    );
});

const mapStateToProps = (state, { index }) => {
    const { shape: visualizerShape } = state.createPreview.present.videoSettings.visualizer;
    const { reflectionType } = state.createPreview.present.videoSettings.visualizer.waveCircles[index].customOptions;
    return { reflectionType, visualizerShape };
}

const mapDispatchToProps = (dispatch) => ({
    updateWaveLayerCustomOptions: (index, key, value) => dispatch(createActions.updateWaveLayerCustomOptions(index, key, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(WaveLayerReflectionTypeListItem);